import React from 'react';
import { View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

interface TabScreenWrapperProps {
  children: React.ReactNode;
  className?: string;
  style?: any;
}

/**
 * TabScreenWrapper - Provides consistent layout for tab screens
 *
 * This wrapper provides a clean SafeAreaView container without aggressive bottom padding.
 * Bottom spacing should be handled by individual screens based on their content type:
 * - ScrollView content: Use contentContainerStyle with bottom padding
 * - Non-scrollable content: Add bottom padding to final elements
 *
 * This allows content to flow naturally while ensuring bottom elements can always
 * be scrolled above the floating add button.
 *
 * Features:
 * - SafeAreaView for proper top spacing
 * - No bottom padding (handled by individual screens)
 * - Consistent base layout across all tab screens
 */
export function TabScreenWrapper({ children, className = '', style = {} }: TabScreenWrapperProps) {
  return (
    <SafeAreaView
      className={`flex-1 ${className}`}
      style={style}
    >
      <View className="flex-1">
        {children}
      </View>
    </SafeAreaView>
  );
}

/**
 * Utility constant for bottom padding calculations
 * Use this in ScrollView contentContainerStyle or bottom elements
 * to ensure content can be scrolled above the floating add button
 */
export const TAB_BOTTOM_SPACING = 30;
